import Flex from '@/components/Flex';
import Image from 'next/image';

import downloadRollinewsImg from '@/images/download_rollinews.png';

import { DOWNLOAD_URLS } from '@/constants/urls';
import { faAndroid, faApple } from '@fortawesome/free-brands-svg-icons';
import { CustomButton } from '../CustomButton';
import { CustomIcon } from '../CustomIcon';
import { Modal } from '../Modal';
import styles from './DownloadAppModal.module.scss';
import { IDownloadAppModal } from './DownloadAppModal.types';

export const DownloadAppModal: React.FC<IDownloadAppModal> = ({
  isOpen,
  setIsOpen,
}) => {
  const openExternalLink = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      title="Descarga Rollin News en tu teléfono"
      large
    >
      <Flex flexDirection="column" alignItemsCenter gap="20px">
        <Image
          src={downloadRollinewsImg}
          alt="image_phone"
          className={styles.image}
        />

        <ul className={styles.bullets}>
          <li>Accede a todas las funciones de la aplicación</li>
          <li>Crea y guarda listas con los videos mas relevantes</li>
          <li>Recibe notificaciones de las noticias mas importantes</li>
          <li>Ordena y activa las categorías de contenido de tu interés</li>
        </ul>
        <Flex gap="10px" wrap justifyCenter>
          <CustomButton
            title="Descargar para Android"
            onClick={() => openExternalLink(DOWNLOAD_URLS.android)}
          >
            <CustomIcon icon={faAndroid} />
            Descargar para Android
          </CustomButton>

          <CustomButton
            title="Descargar para iOS"
            onClick={() => openExternalLink(DOWNLOAD_URLS.ios)}
          >
            <CustomIcon icon={faApple} />
            Descargar para iOS
          </CustomButton>
        </Flex>
      </Flex>
    </Modal>
  );
};
